<ion-item [disabled]="disabled">
  <ion-label>Asistent</ion-label>
  <ion-grid *ngIf="assignments$$ | async as assignments" class="wrapper">
    <ion-row *ngFor="let a of assignments" class="assignment">
      <ion-col class="status">
        <span
          class="content"
          [style.background-color]="a.status.color"
          (click)="onAssignmentNameClick($event)"
          title="{{ a.fullname }}"
        >
          {{ a.fullname }}
        </span>
      </ion-col>
      <ion-col class="transit">
        <span class="content">
          přejezd
          <ion-input
            #transitDurationInput
            type="number"
            min="0"
            step="5"
            name="assignment-{{ a.id }}-transit-duration"
            [disabled]="disabled || (!areAssignmentsEditable && keepAssignmentEditable !== a.id)"
            [value]="+a.transitDurationMinutes"
            (ionChange)="onTransitDurationChange($event, a.id)"
          ></ion-input>
          min
        </span>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-item>
